import { render, staticRenderFns } from "./ReserveQuantityFirst.vue?vue&type=template&id=01c990b4&"
import script from "./ReserveQuantityFirst.vue?vue&type=script&lang=ts&"
export * from "./ReserveQuantityFirst.vue?vue&type=script&lang=ts&"
import style0 from "./ReserveQuantityFirst.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports